import sendHttpPostRequest from "./sendHttpPostRequest";
import sendHttpGetRequest from "./sendHttpGetRequest";
import sendHttpPutRequest from "./sendHttpPutRequest";
import sendHttpDeleteRequest from "./sendHttpDeleteRequest";

const AdminService = {
  getConsultantsAdmin: () => {
    return sendHttpGetRequest("/admin/consultants");
  },
  getArrayItem: (userId, objectId, objectName, collectionName) => {
    return sendHttpPostRequest(
      "/admin/user/getcollectionitem",
      JSON.stringify({
        userId: userId,
        objectId: objectId,
        objectName: objectName,
        collectionName: collectionName,
      })
    );
  },

  getArrayItems: (userId, collectionName) => {
    return sendHttpPostRequest(
      "/admin/user/getcollectionitems",
      JSON.stringify({
        userId: userId,
        collectionName: collectionName,
      })
    );
  },

  deleteArrayItem: (userId, objectToDeleteId, collectionToDelete) => {
    return sendHttpPostRequest(
      "/admin/user/deletecollectionitem",
      JSON.stringify({
        userId: userId,
        objectToDeleteId: objectToDeleteId,
        collectionToDelete: collectionToDelete,
      })
    );
  },
  updateArrayItem: (userId, objectToUpdate, collectionToUpdate) => {
    return sendHttpPutRequest(
      "/admin/user/updatecollectionitem",
      JSON.stringify({
        userId: userId,
        objectToUpdate: objectToUpdate,
        collectionToUpdate: collectionToUpdate,
      })
    );
  },
  generateRegisterKey: () => {
    return sendHttpGetRequest("/admin/register/generateregisterkey");
  },
  addTranslation: (userId, language, seedFromLanguage) => {
    return sendHttpPostRequest(
      "/admin/user/addtranslation",
      JSON.stringify({
        userId: userId,
        language: language,
        seedFromLanguage: seedFromLanguage,
      })
    );
  },

  createProfileVersion: (userId, name, sourceLanguage) => {
    return sendHttpPostRequest(
      "/admin/user/createprofileversion",
      JSON.stringify({
        userId: userId,
        name: name,
        sourceLanguage: sourceLanguage,
      })
    );
  },

  updateTranslationInfo: (userId, translationId, object) => {
    return sendHttpPutRequest(
      "/admin/user/updatetranslationinfo",
      JSON.stringify({
        userId: userId,
        translationId: translationId,
        object: object,
      })
    );
  },

  createNestedArrayItem: (
    userId,
    firstLevelCollectionItemId,
    firstLevelCollection,
    objectToAdd,
    collectionToAddTo
  ) => {
    return sendHttpPostRequest(
      "/admin/user/addnestedsubdocument",
      JSON.stringify({
        userId: userId,
        firstLevelCollectionItemId: firstLevelCollectionItemId,
        objectToAdd: objectToAdd,
        firstLevelCollection: firstLevelCollection,
        collectionToAddTo: collectionToAddTo,
      })
    );
  },

  updateNestedArrayItem: (
    userId,
    firstLevelCollectionItemId,
    firstLevelCollection,
    objectToUpdate,
    collectionToUpdate
  ) => {
    return sendHttpPutRequest(
      "/admin/user/updatenestedsubdocument",
      JSON.stringify({
        userId: userId,
        firstLevelCollectionItemId: firstLevelCollectionItemId,
        objectToUpdate: objectToUpdate,
        firstLevelCollection: firstLevelCollection,
        collectionToUpdate: collectionToUpdate,
      })
    );
  },

  deleteNestedArrayItem: (
    userId,
    firstLevelCollectionItemId,
    firstLevelCollection,
    objectToRemoveId,
    collectionToRemove
  ) => {
    return sendHttpPostRequest(
      "/admin/user/removenestedsubdocument",
      JSON.stringify({
        userId: userId,
        firstLevelCollectionItemId: firstLevelCollectionItemId,
        objectToRemoveId: objectToRemoveId,
        firstLevelCollection: firstLevelCollection,
        collectionToRemove: collectionToRemove,
      })
    );
  },

  deleteUser: (user) => {
    return sendHttpDeleteRequest("/admin/user/delete", JSON.stringify(user));
  },

  updateRole: (role) => {
    return sendHttpPutRequest("/admin/user/updaterole", JSON.stringify(role));
  },

  updateUserInfo: (userId, userInfo) => {
    return sendHttpPutRequest(
      "/admin/user/updateuserinfo",
      JSON.stringify({
        userId: userId,
        object: userInfo,
      })
    );
  },

  uploadProfilePic: (userId, formData) => {
    formData.append("userId", userId);
    return fetch("/admin/user/uploadprofilepic", {
      method: "put",
      body: formData,
    }).then((res) => {
      if (res.status !== 401) {
        return res.json().then((data) => data);
      } else {
        return { message: { msgBody: "Unauthorized", msgError: true } };
      }
    });
  },

  changeUserPassword: (userId, newPassword) => {
    return sendHttpPutRequest(
      "/admin/user/changeuserpassword",
      JSON.stringify({
        userId: userId,
        newPassword: newPassword,
      })
    );
  },
};

export default AdminService;
